<template>
    <!-- 三方票团购自助换票管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'thirdProductManage')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <!-- <a-form-item label="票券id">
                        <a-input placeholder="请输入" v-decorator="['ticketId']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="票券内部名称">
                        <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
                    </a-form-item> -->
                    <a-form-item label="三方平台类型">
                        <a-select allowClear placeholder="请选择" v-decorator="['thirdType']" @select="search">
                            <a-select-option v-for="item,key of thirdTypeObj" :key="key" :value="key">{{item}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="sku_id">
                        <a-input placeholder="请输入" v-decorator="['skuId']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button :loading="loading" @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card :bordered="false">
                <a-button slot="extra" type="primary" @click="openModal({id: '',thirdType: undefined})">新增</a-button>
                <a-table
                :scroll="{y: 560}"
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                @change="changePage"
                :rowKey="(record, index) => index"
                >
                <template slot="ticketTemplateId" slot-scope="ticketTemplateId, row">{{row.ticketTemplate.ticketTemplateId}}</template>
                <template slot="name" slot-scope="name, row">{{row.ticketTemplate.name}}</template>
                <template slot="thirdType" slot-scope="key">{{thirdTypeObj[key]}}</template>
                <span slot="action" slot-scope="a,row">
                    <a class="text-primary" @click="openModal(row)">编辑</a>
                    <a-divider type="vertical" />
                    <a-popconfirm
                        title="请确认是否要删除？删除后会导致已换票的用户无法核销入园，若票券已过有效期可删除"
                        @confirm="deleteSku(row.id)"
                        >
                        <a class="text-primary">删除</a>
                    </a-popconfirm>
                </span>
                </a-table>
            </a-card>
            <a-modal
            centered
            :title="editItem.id ? '编辑' : '新增'"
            :width="700"
            :visible="visible"
            :destroyOnClose="true"
            :confirmLoading="confirmLoading"
            @cancel="visible = false"
            @ok="save"
            >
                <a-form :form="formModal">
                    <a-form-item v-if="editItem.shopName ? editItem.shopName : shopName" label="适用门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        {{editItem.shopName ? editItem.shopName : shopName}}
                    </a-form-item>
                    <a-form-item label="自营票券" required :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a v-if="!ticket.ticketTemplateId" class="text-primary ml8" @click="openTicketSelect">选择票券</a>
                        <section class="flex flex-start" v-else>
                            <div class="gooods-length">（ID: {{ticket.ticketTemplateId}}）{{ticket.name}}</div>
                            <a-input v-show="false" disabled v-decorator="['ticketId', {initialValue: ticket.ticketTemplateId, rules: [{required: true, message: '请输入票券名称',}]}]"></a-input>
                            <a class="text-primary ml8 text-right" @click="openTicketSelect">修改</a>
                        </section>
                    </a-form-item>
                    <a-form-item label="三方平台类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select :disabled="!!editItem.id" placeholder="请选择" v-decorator="['thirdType',{initialValue: editItem.id ? editItem.thirdType : undefined,rules: [{required: true, message: '请选择'}]}]" @change="onChangeThirdType">
                            <a-select-option v-for="item,key of thirdTypeObj" :key="key" :value="key">{{item}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="选择sku" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select show-search v-decorator="['skuId',{rules: [{required: true, message: '请选择（输入skuId搜索）'}]}]" placeholder="请选择（输入skuId搜索）">
                            <a-select-option :vlaue="item.skuId" v-for="item in skuList" :key="item.skuId">
                                {{item.skuName}}
                                <a-badge aria-labal :color="item.hasMapping ? '#A60A0A' : '#62D18E'" :text="item.skuId" />
                            </a-select-option>
                        </a-select>
                        <div v-show="formModal.getFieldValue('skuId')">选中的skuId：{{formModal.getFieldValue('skuId')}}</div>
                    </a-form-item>
                </a-form>
            </a-modal>
        <ticket-picker tableType="radio" goodType="ticket" ref="ticketPicker" :ticketList="ticketList" @confirmSelectTicket='confirmSelectTicket'></ticket-picker>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    import ticketPicker from "@/components/modules/platform/tickets-picker.component"
    export default {
        name: "exchangeGiftOrder",
        props: {},
        data() {
            const columns = [
                {
                    title: "票券id",
                    dataIndex: "ticketTemplateId",
                    scopedSlots: { customRender: "ticketTemplateId" }
                },
                {
                    title: '内部名称',
                    dataIndex: 'name',
                    scopedSlots: { customRender: "name" }
                },
                {
                    title: '适用门店',
                    dataIndex: 'shopName',
                },
                {
                    title: "sku_id",
                    dataIndex: "skuId",
                },
                {
                    title: 'sku名称',
                    dataIndex: 'skuName'
                },
                {
                    title: '三方平台类型',
                    dataIndex: 'thirdType',
                    scopedSlots: { customRender: "thirdType" }
                },
                {
                    title: "操作",
                    key: "action",
                    scopedSlots: { customRender: "action" },
                }
            ];
            return {
                labelCol: {span: 5},
                wrapperCol: {span: 19},
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                visible: false,
                confirmLoading: false,
                skuList: [],
                editItem: {},
                ticket: {},
                ticketList: [],
                thirdTypeObj: {'DY':'抖音','MT':'美团','ZWY':'自我游'},
            };
        },
        components: {
            ticketPicker,
        },
        computed: {
            ...mapGetters(["shopId","shopName"])
        },
        methods: {
            openTicketSelect() {
                this.$refs.ticketPicker.visible = true;
                this.ticket = {};
            },
            getTicketList() {
                if(!this.shopId) return
                this.$api.totalPlatform.getTotalTicketList({
                    body: {
                        // isMiniSell: true,
                        sellShopId: this.shopId
                    }
                }).then(res => {
                    res = res || [];
                    res.forEach(el => {
                        el.goodsType = 1;
                        el.value = el.ticketTemplateId;
                    })
                    this.ticketList = res;
                });
            },
            confirmSelectTicket(ticket) {
                console.log(ticket);
                
                if (!ticket || !ticket.length) {
                    this.$message.warning("请先选择票券");
                    return;
                }
                this.ticket = ticket[0];
                this.formModal.setFieldsValue({ticketId: this.ticket.ticketTemplateId})
            },
            handleReset() {
                this.form.resetFields();
                this.pagination.current = 1;
                this.pagination.pageSize = 20;
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            getList() {
                if(!this.shopId) return
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.loading = true;
                    this.$api.shopTicket.mappingList({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            shopId: this.shopId == -1 ? undefined : this.shopId
                        })
                    })
                    .then(res => {
                        this.loading = false;
                        this.dataSource = res ? res.list : [];
                        this.pagination.total = res ? res.total : 0;
                    })
                    .catch(err => {
                        this.loading = false;
                    })
                });
            },
            getSkuList(thirdType) {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.$api.shopTicket.skuQuery({
                        body: {
                            thirdType: thirdType,
                            shopId: this.editItem.shopId ? this.editItem.shopId : this.shopId
                        }
                    }).then(res => {
                        this.skuList = res;
                    })
                });
            },
            onChangeThirdType(e) {
                this.formModal.setFieldsValue({skuId: undefined})
                this.getSkuList(e)
            },
            save() {
                if (!this.ticket.ticketTemplateId) {
                    this.$message.warning("请先选择票券");
                    return;
                }
                this.formModal.validateFields((err, values) => {
                    if (err) return;
                    this.confirmLoading = true;
                    this.$api.shopTicket[this.editItem.id ? 'mappingEdit' : 'mappingAdd']({
                        body: Object.assign(values, {
                            id: this.editItem.id,
                            skuName: this.skuList.filter(e => e.skuId == values.skuId)[0].skuName,
                            shopId: this.editItem.shopId ? this.editItem.shopId : this.shopId,
                            shopName: this.editItem.shopName ? this.editItem.shopName : this.shopName,
                        })
                    })
                    .then(res => {
                        this.$message.success('操作成功');
                        this.confirmLoading = false;
                        this.visible = false;
                        this.getList();
                    })
                    .catch(err => {
                        this.confirmLoading = false;
                    })
                });
            },
            openModal(item={}) {
                this.editItem = item;
                this.skuList = [];
                if(item.id) {
                    this.getSkuList(item.thirdType);
                    this.$nextTick(() =>{
                        this.formModal.setFieldsValue(item);
                    })
                    this.ticket = item.ticketTemplate;
                }else {
                    if(this.shopId == -1) {
                        this.$message.warning('总平台不支持新增映射关系，请切换至具体门店再新增')
                        return
                    }
                }
                this.getTicketList();
                this.visible = true;
            },
            deleteSku(id) {
                this.$api.shopTicket.mappingDelete({
                    params: {
                        id: id
                    }
                }).then(res => {
                    this.getList();
                    this.$message.success('操作成功');
                })
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.formModal = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList();
        },
        watch: {
            shopId() {
                this.getList();
            }
        }
    };
</script>
<style lang="scss">
</style>